import { render, staticRenderFns } from "./pt-feedback-detail.vue?vue&type=template&id=1ad98ed3&"
import script from "./pt-feedback-detail.vue?vue&type=script&lang=js&"
export * from "./pt-feedback-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports